/** Mirror `types/assetConditions.ts` — value exports for Zod (CRA cannot bundle `../types`). */
export const TEMPLATE_DEFAULT_CONDITION_VALUES = ['new', 'pre_loved', 'damaged', 'missing'] as const;
export type TemplateDefaultCondition = (typeof TEMPLATE_DEFAULT_CONDITION_VALUES)[number];

export const INSTANCE_CONDITION_VALUES = [
  'new',
  'pre_loved',
  'good',
  'damaged',
  'needs_repair',
  'missing',
  'retired',
] as const;
export type InstanceCondition = (typeof INSTANCE_CONDITION_VALUES)[number];
